import { Controller } from "@hotwired/stimulus";

// Provides tier downgrade awareness on the admin subscription edit form.
// Displays a visual warning when the selected tier is lower than the current tier.
export default class extends Controller {
  static targets = ["tierSelect"];

  static values = {
    currentTier: String,
  };

  // Tier rank mapping for downgrade detection.
  static TIER_RANKS = { free: 0, pro: 1, studio: 2, beta_tester: 3 };

  connect() {
    if (this.hasTierSelectTarget) {
      this.currentTierValue =
        this.tierSelectTarget.querySelector("option[selected]")?.value ||
        this.tierSelectTarget.value;
    }
  }

  checkDowngrade() {
    if (!this.hasTierSelectTarget) return;

    const newTier = this.tierSelectTarget.value;
    const currentRank = this.constructor.TIER_RANKS[this.currentTierValue] ?? 0;
    const newRank = this.constructor.TIER_RANKS[newTier] ?? 0;

    if (newRank < currentRank) {
      this.tierSelectTarget.classList.add(
        "border-red-500",
        "ring-1",
        "ring-red-500"
      );
    } else {
      this.tierSelectTarget.classList.remove(
        "border-red-500",
        "ring-1",
        "ring-red-500"
      );
    }
  }
}
